/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_Tab_One_TimeInputs */

const en_admin_payments_tab_one_time = /** @type {(inputs: Admin_Payments_Tab_One_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One-Time`)
};

const zh_admin_payments_tab_one_time = /** @type {(inputs: Admin_Payments_Tab_One_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一次性`)
};

/**
* | output |
* | --- |
* | "One-Time" |
*
* @param {Admin_Payments_Tab_One_TimeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_payments_tab_one_time = /** @type {((inputs?: Admin_Payments_Tab_One_TimeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_Tab_One_TimeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_payments_tab_one_time(inputs)
	return zh_admin_payments_tab_one_time(inputs)
});
export { admin_payments_tab_one_time as "admin.payments.tab_one_time" }